module.exports = __webpack_public_path__ + "02-thumbnail.jpg?f5aafc755333e06662eaf502509d4520";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/02-thumbnail.jpg
// module id = 39
// module chunks = 0